import { render } from "./ConsultationDraftBlock.vue?vue&type=template&id=796a9b26&scoped=true"
import script from "./ConsultationDraftBlock.vue?vue&type=script&lang=js"
export * from "./ConsultationDraftBlock.vue?vue&type=script&lang=js"

import "./ConsultationDraftBlock.vue?vue&type=style&index=0&id=796a9b26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796a9b26"]])

export default __exports__